var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 12.257,
    y: 31.594,
    width: 174.75,
    height: 151.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 73.77,
    y: 69.365,
    width: 102.459,
    height: 102.682,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.492)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.493)",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.985 46.794)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.51, -46.79)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.881-271.861c-1.07-4.013-3.682-6.986-6.351-9.884a141.654,141.654,0,0,0-16.211-14.578c-10.191-8.1-20.876-15.536-31.676-22.826-5.141-3.47-8.783-8.327-12.039-13.474a35.108,35.108,0,0,1-5.789-21.07c.818-14.336,6.553-26.168,19.1-34.193a31.563,31.563,0,0,1,15.1-4.52,40.6,40.6,0,0,1,24.734,5.783,53.449,53.449,0,0,1,12.288,11.119c.843.99,1.027.77,1.747-.05,6.153-7.007,12.947-13.2,22.432-15.49,10.378-2.5,20.552-2.48,30.012,3.26,7.569,4.587,12.436,11.353,15.674,19.36a42.917,42.917,0,0,1,3.109,16.234,35.81,35.81,0,0,1-6.243,20.023c-.526.791-.9.848-1.416.014a8.231,8.231,0,0,0-1.092-1.331c-1.47-1.508-1.488-1.5-.407-3.4,5.18-9.05,5.152-18.5,1.934-28.063-2.752-8.188-7.615-14.876-15.314-19.328a27.652,27.652,0,0,0-10.53-3.253,37.01,37.01,0,0,0-20.934,3.565,22.857,22.857,0,0,0-5.324,3.512c-2.536,2.224-5.062,4.452-7.371,6.911a6.649,6.649,0,0,0-1.127,1.625,4.689,4.689,0,0,1-4.377,2.774,4.787,4.787,0,0,1-4.449-2.878c-1-1.958-2.785-3.292-4.3-4.836a34.964,34.964,0,0,0-17.731-10.04,36.786,36.786,0,0,0-17.494.291c-6.07,1.582-10.793,5.2-14.647,9.934a38.461,38.461,0,0,0-8.426,22.131c-.6,8.408,2.183,15.816,7.086,22.592a41.85,41.85,0,0,0,11.168,10.661,358.939,358.939,0,0,1,35.275,26,95.435,95.435,0,0,1,12.659,12.318c.721.876,1.2.926,1.931-.014a51.849,51.849,0,0,1,5.364-5.708c.212-.2.407-.557.76-.426.371.135.249.529.241.812a12.224,12.224,0,0,0,.508,4.3c.191.553-.151.9-.49,1.27-1.164,1.277-2.345,2.54-3.444,3.871A19.472,19.472,0,0,0,374.881-271.861Z",
    transform: "translate(-275.25 439.43)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.51, -46.79)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.868-345.754c0-2.979-.007-5.962,0-8.945.014-3.112,1.558-4.63,4.709-4.634,5.294,0,10.593-.032,15.887.025,1.21.011,1.619-.312,1.6-1.569-.065-5.341-.036-10.682-.025-16.023,0-3.029,1.622-4.742,4.681-4.77q9.013-.076,18.026,0c3.252.025,4.918,1.748,4.932,5.007.022,5.251.036,10.5-.018,15.754-.011,1.2.327,1.622,1.583,1.6,5.295-.065,10.592-.032,15.89-.022,2.714,0,4.232,1.346,4.534,4.027a59.543,59.543,0,0,1,.1,7.2c-.029,4.182.212,8.371-.14,12.545a3.871,3.871,0,0,1-3.439,3.679,12.262,12.262,0,0,1-1.992.151c-5.072.011-10.147.036-15.219-.015-1.152-.011-1.551.341-1.54,1.526.054,5.294.029,10.593.022,15.891,0,3.04-1.493,4.71-4.519,4.745q-9.212.108-18.424,0c-2.976-.039-4.473-1.7-4.48-4.652-.011-5.294-.036-10.592.022-15.887.014-1.217-.341-1.633-1.58-1.619-5.029.054-10.061.025-15.09.018a13.347,13.347,0,0,1-1.859-.111A3.945,3.945,0,0,1,319.879-336c-.025-3.249,0-6.5,0-9.749Zm45.148-21.45c0-2.714-.043-5.427.021-8.141.025-1.106-.334-1.461-1.443-1.45-5.029.047-10.058.018-15.086.022-1.784,0-1.788,0-1.791,1.744,0,5.075.021,10.147-.011,15.219-.021,3.3-1.59,4.9-4.863,5.108-.442.025-.89.014-1.332.014-4.72,0-9.437.032-14.153-.022-1.231-.014-1.619.42-1.608,1.626q.07,7.613,0,15.219c-.015,1.17.377,1.536,1.543,1.522,5.115-.05,10.234-.025,15.352-.018,3.51,0,5.1,1.608,5.111,5.154.011,4.982.036,9.968-.018,14.95-.015,1.2.305,1.651,1.565,1.637q7.607-.091,15.219,0c1.177.011,1.529-.388,1.515-1.547-.05-5.072-.025-10.144-.018-15.219,0-3.564,1.64-5.19,5.248-5.2,5.072-.007,10.147-.015,15.219.011.951,0,1.479-.161,1.468-1.3q-.064-7.742,0-15.485c.011-1.113-.481-1.346-1.454-1.335-3.2.032-6.407.021-9.613.007-2.265-.011-4.544.079-6.8-.111-2.682-.229-4.038-1.845-4.063-4.523C365-361.953,365.019-364.576,365.016-367.2Z",
    transform: "translate(-230.85 466.32)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.61cd02fedc2a57584bf278903ae76800.svg";
export { ForwardRef as ReactComponent };